/* Koleksiyon sayfası etkileşimleri: sıralama, grid/list, fiyat slider, filtre */
(function () {
  'use strict';

  // Sıralama: seçim değişince sort_by ile yönlendir (mevcut filtreleri koru)
  const sort = document.querySelector('[data-sort]');
  if (sort) {
    sort.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', sort.value);
      url.searchParams.delete('page');
      window.location.assign(url.toString());
    });
  }

  // Grid / Liste görünümü
  const grid = document.querySelector('[data-product-grid]');
  document.querySelectorAll('[data-view]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const view = btn.getAttribute('data-view');
      document.querySelectorAll('[data-view]').forEach((b) => b.classList.toggle('is-active', b === btn));
      if (grid) grid.classList.toggle('product-grid--list', view === 'list');
      try { localStorage.setItem('collection-view', view); } catch (e) {}
    });
  });
  // Kayıtlı görünümü uygula
  try {
    const saved = localStorage.getItem('collection-view');
    if (saved === 'list') {
      const b = document.querySelector('[data-view="list"]');
      if (b) b.click();
    }
  } catch (e) {}

  // Çift uçlu fiyat kaydırıcısı: sayı kutularıyla senkron, formu Uygula ile gönderir
  const slider = document.querySelector('[data-price-slider]');
  if (slider) {
    const minThumb = slider.querySelector('[data-slider-min]');
    const maxThumb = slider.querySelector('[data-slider-max]');
    const fill = slider.querySelector('[data-slider-fill]');
    const priceMin = document.querySelector('[data-price-min]');
    const priceMax = document.querySelector('[data-price-max]');
    const max = Number(slider.dataset.max) || 0;
    if (minThumb && maxThumb && fill && max > 0) {
      const pct = (v) => Math.max(0, Math.min(100, (v / max) * 100));
      const paint = () => {
        let lo = Number(minThumb.value);
        let hi = Number(maxThumb.value);
        if (lo > hi) { const t = lo; lo = hi; hi = t; }
        fill.style.left = pct(lo) + '%';
        fill.style.width = (pct(hi) - pct(lo)) + '%';
      };
      minThumb.addEventListener('input', () => {
        let lo = Number(minThumb.value);
        const hi = Number(maxThumb.value);
        if (lo > hi) { lo = hi; minThumb.value = hi; }
        if (priceMin) priceMin.value = lo > 0 ? lo : '';
        paint();
      });
      maxThumb.addEventListener('input', () => {
        let hi = Number(maxThumb.value);
        const lo = Number(minThumb.value);
        if (hi < lo) { hi = lo; maxThumb.value = lo; }
        if (priceMax) priceMax.value = hi < max ? hi : '';
        paint();
      });
      if (priceMin) priceMin.addEventListener('input', () => {
        const v = Number(priceMin.value) || 0;
        minThumb.value = Math.min(v, max);
        paint();
      });
      if (priceMax) priceMax.addEventListener('input', () => {
        const v = Number(priceMax.value) || max;
        maxThumb.value = Math.min(v, max);
        paint();
      });
      slider.removeAttribute('hidden');
      paint();
    }
  }

  // ---- Native filtre formu ----
  // Checkbox'lar TIKLANINCA gitmez (form submit değil); kullanıcı istediği kadar seçer,
  // "Sonuçları gör" (type=submit) hepsini TEK GET isteğiyle gönderir. Grup-içi çoklu = VEYA,
  // gruplar arası = VE — Shopify Search & Discovery yönetir. JS yoksa da native form çalışır.
  const form = document.querySelector('[data-filter-form]');
  if (form) {
    const countEl = form.querySelector('[data-apply-count]');
    const refreshCount = () => {
      if (!countEl) return;
      const n = form.querySelectorAll('[data-filter-check]:checked').length;
      if (n > 0) { countEl.textContent = n; countEl.hidden = false; } else { countEl.hidden = true; }
    };
    form.addEventListener('change', (e) => { if (e.target.matches('[data-filter-check]')) refreshCount(); });
    refreshCount();
  }
})();
